import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Modal from "react-modal";
import { StealthProvider } from "./context/StealthModeContext";
import "./index.css";
import "./App.css";
import "./navbar.css";
import "./drawer.css";
import "./discovery.css";
import "./profile.css";
import "./settings.css";
import "./messages.css";
import { ReduxProvider } from "./redux/provider";
import { SnackbarProvider } from "notistack";
import CustomSnackbar from "./components/Snackbar/customSnackbar";

const root = ReactDOM.createRoot(document.getElementById("root"));
Modal.setAppElement("#root");
root.render(
  <React.StrictMode>
    <StealthProvider>
      <ReduxProvider>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          autoHideDuration={4000}
          Components={{
            success: CustomSnackbar,
            error: CustomSnackbar,
            warning: CustomSnackbar,
            info: CustomSnackbar,
            like: CustomSnackbar,
            message: CustomSnackbar,
            favorites:CustomSnackbar,
            default: CustomSnackbar,
          }}
        >
          <App />
        </SnackbarProvider>
      </ReduxProvider>
    </StealthProvider>
  </React.StrictMode>
);
